import { Component, OnInit } from "@angular/core";
import { LoginService } from "../../user/services/login.service";
import { Router } from "@angular/router";
import { BaThemeSpinner } from "../../../theme/services/baThemeSpinner/baThemeSpinner.service";

@Component({
  selector: "intro",
  providers: [LoginService],
  templateUrl: "../templates/intro.html",
})
export class IntroComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private router: Router,
    private spinner: BaThemeSpinner
  ) {}

  ngOnInit() {
    this.spinner.show();
    this.checkLogin();
  }

  checkLogin() {
    return this.loginService.isLogged().subscribe(
      (res) => {
        this.loginSuccess();
        this.spinner.hide();
      },
      (res) => {
        this.loginFailure();
        this.spinner.hide();
      }
    );
  }

  loginSuccess() {
    this.router.navigate(["pages/procedimento"]);
  }

  loginFailure() {
    this.router.navigate(["login"]);
  }
}
